<div class="listing">
    <mat-table [dataSource]="skeletonData" class="listing__table">

      <ng-container matColumnDef="name" class="listing__table__col">
        <mat-header-cell
          *matHeaderCellDef
          >Nome</mat-header-cell
        >
        <mat-cell *matCellDef="let user">
          <span class="skeleton__line first"></span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="logon" class="listing__table__col">
        <mat-header-cell *matHeaderCellDef>Logon</mat-header-cell>
        <mat-cell *matCellDef="let user">
          <span class="skeleton__line"></span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="email" class="listing__table__col">
        <mat-header-cell *matHeaderCellDef>E-mail</mat-header-cell>
        <mat-cell *matCellDef="let user">
          <span class="skeleton__line"></span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="role" class="listing__table__col">
        <mat-header-cell *matHeaderCellDef>Perfil</mat-header-cell>
        <mat-cell *matCellDef="let user">
          <span class="skeleton__line"></span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="status" class="listing__table__col">
        <mat-header-cell
          *matHeaderCellDef
          >Status</mat-header-cell
        >
        <mat-cell *matCellDef="let user">
          <span class="skeleton__line status"></span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="actions" class="listing__table__col">
        <mat-header-cell *matHeaderCellDef class="listing__table__col__actions"
          >Ações</mat-header-cell
        >
        <mat-cell class="actions" *matCellDef="let user">
          <button mat-button disabled>
            <mat-icon fontSet="material-icons">more_vert</mat-icon>
          </button>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="tableCols"></mat-header-row>
      <mat-row *matRowDef="let row; columns: tableCols"></mat-row>
    </mat-table>
  </div>
